var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 215,
    height: 52,
    viewBox: "0 0 215 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.8473 5.52491C32.8473 8.69537 30.3395 11.2343 27.1379 11.2343H24.3816C18.6239 11.2343 13.9473 15.7701 13.9473 21.4718V30.8374L13.9473 46.4749H18.6723V30.8374V22.6556V21.4718C18.6723 18.3013 21.18 15.7624 24.3816 15.7624H27.1379C29.2809 15.7624 31.169 15.2868 32.8473 14.1874C35.6971 12.3158 37.5723 9.07888 37.5723 5.5249L32.8473 5.52491Z",
    fill: "url(#paint0_linear_447_1389)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6723 46.4748V40.7654C18.6723 38.0219 20.9736 35.8436 23.791 35.8436H27.7285C33.079 35.8436 37.5723 31.4551 37.5723 26.1967V15.5654C37.5723 19.2076 35.9973 22.4561 32.8473 24.3264V26.1967C32.8473 28.9402 30.5459 31.3154 27.7285 31.3154H23.791C21.93 31.3154 20.1714 31.6994 18.6723 32.6139C15.9065 34.2905 13.9473 37.336 13.9473 40.7654V46.4748H18.6723Z",
    fill: "url(#paint1_linear_447_1389)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M32.8469 14.087V16.202C32.8469 18.9541 30.5425 21.2749 27.7281 21.2749H23.7906C21.9316 21.2749 20.1694 21.7316 18.6719 22.649V30.8033C18.6719 28.0512 20.9763 25.803 23.7906 25.803H27.7281C33.0728 25.803 37.5719 21.4768 37.5719 16.202V5.5249C37.5719 9.11791 35.6228 12.1202 32.8469 14.087Z",
    fill: "url(#paint2_linear_447_1389)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M71.0445 18.1772L71.331 20.5808C72.5915 18.5492 74.2817 18.2631 75.9433 18.2631C77.6335 18.2631 79.2665 18.9212 80.1545 19.8368L78.3211 23.3562C77.4903 22.6695 76.7168 22.2975 75.399 22.2975C73.2791 22.2975 71.3024 23.4134 71.3024 26.4464V35.6598H67.2344V18.2345H71.0445V18.1772Z",
    fill: "#0E6957"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M84.2799 28.3633C84.5377 30.3948 86.3139 31.8827 89.2073 31.8827C90.7257 31.8827 92.7024 31.3104 93.6191 30.3376L96.226 32.9128C94.4785 34.7154 91.6424 35.6024 89.1214 35.6024C83.4205 35.6024 80.04 32.083 80.04 26.7896C80.04 21.7823 83.4491 18.1484 88.8063 18.1484C94.3353 18.1484 97.773 21.5534 97.1428 28.3633H84.2799ZM93.2753 24.987C93.0175 22.841 91.3273 21.7823 88.9782 21.7823C86.7723 21.7823 84.9675 22.841 84.3659 24.987H93.2753Z",
    fill: "#0E6957"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M110.034 23.0126C108.859 21.9253 107.542 21.5533 105.966 21.5533C104.047 21.5533 102.987 22.1542 102.987 23.1842C102.987 24.2429 103.961 24.8438 106.052 24.9869C109.146 25.1872 113.071 25.8739 113.071 30.2231C113.071 33.113 110.722 35.6023 106.023 35.6023C103.416 35.6023 100.838 35.1731 98.4316 32.6838L100.437 29.7939C101.612 31.0815 104.247 32.0543 106.081 32.0829C107.599 32.1115 109.031 31.3104 109.031 30.1372C109.031 29.0213 108.115 28.5349 105.765 28.4204C102.672 28.1915 98.9759 27.047 98.9759 23.3273C98.9759 19.5504 102.901 18.2056 105.88 18.2056C108.43 18.2056 110.378 18.692 112.269 20.3515L110.034 23.0126Z",
    fill: "#0E6957"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M119.115 12.1396V20.7522C120.576 18.8637 122.381 18.1484 124.243 18.1484C128.913 18.1484 130.947 21.4389 130.947 26.2459V35.5738H126.879V26.3031C126.879 23.3274 125.303 22.0398 123.155 22.0398C120.748 22.0398 119.087 24.0713 119.087 26.532V35.6024H115.019V12.1396H119.115V12.1396Z",
    fill: "#0E6957"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M154.123 12.2827V35.6024H150.112V12.2827H154.123Z",
    fill: "#0E6957"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M173.546 26.8754C173.546 31.6824 170.252 35.6024 164.809 35.6024C159.365 35.6024 156.1 31.711 156.1 26.8754C156.1 22.097 159.423 18.1484 164.751 18.1484C170.137 18.1771 173.546 22.097 173.546 26.8754ZM160.282 26.8754C160.282 29.422 161.801 31.7969 164.837 31.7969C167.874 31.7969 169.392 29.422 169.392 26.8754C169.392 24.3575 167.616 21.9254 164.837 21.9254C161.829 21.9254 160.282 24.3575 160.282 26.8754Z",
    fill: "#0E6957"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M188.615 18.1772L192.483 31.4823L196.665 18.2059H201.134L195.004 35.6026H190.306L187.154 25.3305L184.003 35.6026H179.305L173.146 18.1772H177.643L181.826 31.4823L185.665 18.1772H188.615Z",
    fill: "#0E6957"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M60.1009 16.5747H64.9424V12.2827H60.1009C54.7724 12.2827 50.418 16.6319 50.418 21.9539V32.083C50.418 32.1402 50.418 32.1974 50.418 32.2546V35.6024H54.7151V32.2546C54.7151 29.2789 57.1216 26.8754 60.1009 26.8754H64.9997V22.5834H60.1009C58.0956 22.5834 56.2621 23.1843 54.7151 24.2144V21.9539C54.7151 18.9782 57.1502 16.5747 60.1009 16.5747Z",
    fill: "#0E6957"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M142.922 16.5747H147.764V12.2827H142.922C137.594 12.2827 133.239 16.6319 133.239 21.9539V32.083C133.239 32.1402 133.239 32.1974 133.239 32.2546V35.6024H137.536V32.2546C137.536 29.2789 139.943 26.8754 142.922 26.8754H147.821V22.5834H142.922C140.917 22.5834 139.083 23.1843 137.536 24.2144V21.9539C137.536 18.9782 139.943 16.5747 142.922 16.5747Z",
    fill: "#0E6957"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_447_1389",
    x1: 25.7567,
    y1: 36.0566,
    x2: 25.7567,
    y2: 5.10371,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#239F77"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B4C353"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_447_1389",
    x1: 25.7438,
    y1: 22.6815,
    x2: 25.7438,
    y2: 55.4237,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#239F77"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E6957"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_447_1389",
    x1: 28.0701,
    y1: 36.0305,
    x2: 28.0701,
    y2: 5.18155,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#239F77"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B4C353"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.150a3d64acdc9546e81794f78b4e637a.svg";
export { ForwardRef as ReactComponent };